import React from 'react';

/**
 * Club website split — same copy format as BookingSplit, reversed row like
 * MembershipSplit; the laptop image is a real club site screenshot, used as
 * supplied (own frame, transparent background).
 */
const WebsiteSplit = (): React.JSX.Element => (
  <section className="oq-website anchor-section" id="website">
    <div className="oq-container oq-website__inner">
      <div className="oq-website__row">
        <div className="oq-website__copy">
          <div className="oq-website__kicker oq-bebas">CUSTOMISED CLUB WEBSITE</div>
          <h2 className="oq-website__title oq-bebas">A club website that runs itself</h2>
          <p className="oq-website__subtitle">
            A templated site that always looks smart — you provide the content, and our template
            options take care of the design. No page builder to fight, and no committee member
            stuck maintaining it.
          </p>
          <div className="oq-website__bullets">
            <div className="oq-website__bullet">
              <i className="mdi mdi-check-circle" aria-hidden="true" />
              <span>
                <b>Your domain, your brand</b> — template options with your colours, logo and
                photography, live at your club&apos;s own address.
              </span>
            </div>
            <div className="oq-website__bullet">
              <i className="mdi mdi-check-circle" aria-hidden="true" />
              <span>
                <b>Always in sync</b> — sessions and posts published in the app appear on the
                site instantly.
              </span>
            </div>
            <div className="oq-website__bullet">
              <i className="mdi mdi-check-circle" aria-hidden="true" />
              <span>
                <b>Memberships &amp; payments built in</b> — joining, renewing and booking all
                happen right on the site.
              </span>
            </div>
          </div>
          <a
            href="https://www.3ctri.org.uk"
            target="_blank"
            rel="noopener noreferrer"
            className="oq-website__link"
          >
            See a live club site <i className="mdi mdi-arrow-right" aria-hidden="true" />
          </a>
        </div>

        <div className="oq-website__laptop" aria-hidden="true">
          {/* Real club-site screenshot, used exactly as supplied — it carries its
              own laptop frame on a transparent background. */}
          <img
            src="/images/club-website.png"
            alt=""
            className="oq-website__shot"
            loading="lazy"
            width="1748"
            height="1068"
          />
        </div>
      </div>
    </div>
  </section>
);

export default WebsiteSplit;
